import React from 'react';
import { Header } from 'semantic-ui-react';
import Image from '../../../atoms/Image';

const OnlineOrderingNavigationHeader = ({ logo, businessName, atBaseHeight }) => {
  const Logo = ({ className }) => <Image src={logo} className={className} />;
  const BusinessName = ({ className }) => (
    <Header as="h3" className={className}>
      {businessName}
    </Header>
  );

  return logo.length > 0 ? (
    <React.Fragment>
      <Logo className={`logo${atBaseHeight ? ' hide' : ' show'}`} />
      <BusinessName className={`business-name${atBaseHeight ? ' show' : ' hide'}`} />
    </React.Fragment>
  ) : (
    <BusinessName />
  );
};

export default OnlineOrderingNavigationHeader;
